import { jsonGet, jsonPost } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import { formatPhoneNumber, numbersOnly } from '../utilities/utility';

const mfaEnrollSmsSection = '#mfa-enrollment-sms-type';
const mfaEnrollVoiceSection = '#mfa-enrollment-voice-type';
const mfaEnrollSetup = '.mfa-enrollment-setup';
const mfaEnrollCommonSection = '.mfa-enrollment-type';
const mfaEnrollSetupSection = '#mfa-enrollment-section';
const mfaEnrollPhoneInput = '.mfa-enrollment-type-phone-code';
const mfaEnrollVerifyInput = '.mfa-enrollment-type-phone-verify';
const mfaEnrollOtpResendMessage = '.mfa-enroll-otp-expiry-time';
const mfaEnrollPhoneVerify = '.mfa-enrollment-type-phone-input';
const mfaEnrollEmptyError = '.mfa-phone-empty-error';
const mfaEnrollInvalidPhoneError = '.mfa-phone-invalid-error';
const mfaEnrollPhoneSection = '.mfa-enrollment-type-phone-section';
const mfaEnrollCtyCode = '.mfa-enrollment-type-country-code';
const mfaEnrollStateDropdown = '.mfa-enrollment-type-state';
const mfaEnrollInvalidPhoneNumber = '.mfa-enrollment-type-phone-invalid';
const mfaEnrollInvalidCode = '.mfa-enrollment-type-sendcode-invalid';
const mfaEnrollGeneralErrorSection = '.mfa-enroll-invalid-field-error';
const mfaTypeAuth = '.mfa-auth-type';
const mfaTypeAuthEnrollText = 'enroll';
const mfaTypeAuthEnforceText = 'enforce';
const mfaEnrollOtpTimer = 30;
const mfaEnrollCodeSentText = 'Sent';
const mfaEnrollCodeSentVoice = 'Calling';
const mfaEnrollCodeReSendText = 'Resend code';
const mfaEnrollCodeReSendVoice = 'Redial';
const mfaEnrollSmsSetupBtnId = 'mfa-enrollment-sms-setup';
const mfaEnrollSmsVerifyBtnId = 'mfa-enrollment-type-verify-btn';
const mfaEnrollSendCodeBtnId = 'mfa-enrollment-type-send-btn';
const mfaEnrollSetupTypeSms = 'sms';
const mfaEnrollSetupTypeCall = 'call';
const mfaEnrollSetupTypeEmail = 'email';
const mfaEnrollSendCodeFail = 'FAILURE';
const mfaEnrollSendCodePass = 'MFA_ENROLL_ACTIVATE';
const mfaEnforceChallengeCheck = 'MFA_CHALLENGE';
const mfaEnrollSuccessCheck = 'SUCCESS';
const mfaEnrollExpiryCheck = 'EXPIRED';
const mfaEnforceTypeDropdown = '#mfa-enforcement-type-dropdown';
const mfaEnforceTypeSection = '#mfa-enforcement-type-dropdown-icon';
const mfaEnforceTypeSms = '#mfa-enforcement-type-sms';
const mfaEnforceTypeVoice = '#mfa-enforcement-type-voice';
const mfaEnforceTypeEmail = '#mfa-enforcement-type-email';
const mfaEnforceTypeAll = '.mfa-enrollment-type-icon-circle';
const mfaEnforceAuthTypeAll = '.mfa-enforcement-auth-type';
const mfaEnforceAuthTypeId = '#mfa-enforcement-auth-type';
const mfaEnforceAuthTypeSmsId = '#mfa-enforcement-auth-type-sms';
const mfaEnforceAuthTypeVoiceId = '#mfa-enforcement-auth-type-call';
const mfaEnforceAuthTypeEmailId = '#mfa-enforcement-auth-type-email';
const mfaEnforceContactInfoAll = '.mfa-enforcement-contact-info';
const mfaEnforceContactInfoText = '#mfa-enforcement-phone-number-text';
const mfaEnforceContactInfoEmail = '#mfa-enforcement-email-text';
const mfaEnforceFactorId = '#mfa-enforcement-factor-id';
const mfaEnforceSendCodeText = 'Send code';
const mfaEnforceVoiceCallText = 'Call';
const mfaEnforceGeneralMismatchOtp = '.mfa-enrollment-type-token-mismatch';
const mfaEnrollmentTypeGeneralError = '.mfa-enrollment-type__resend-section';
const mfaEnforceResendMsgEle = '#mfa-enrollment-type-resend-msg';
const mfaEnforceResendMsgTextEle = '.mfa-enforcement-sms-resend-msg';
let mfaResendCodeAjaxReq = true;
let mfaVerifyCodeAjaxReq = true;
let cboxOptions = {
  maxWidthLg: '550px',
  maxHeightLg: '800px',
  maxWidthMd: '550px',
  maxHeightMd: '500px',
  maxWidthSm: 'auto',
  maxHeightSm: 'auto'
};
let mfaSessionTimeout = $('#sessionTime').val() / 60;
const mfaOktaFunction = {
  checkWidth() {
    if (window.innerWidth >= 1368) {
      return cboxOptions.maxWidthLg;
    } else if (window.innerWidth >= 768 && window.innerWidth < 1368) {
      return cboxOptions.maxWidthMd;
    } else {
      return cboxOptions.maxWidthSm;
    }
  },
  checkHeight() {
    if (window.innerHeight >= 1368) {
      return cboxOptions.maxHeightLg;
    } else if (window.innerHeight >= 768 && window.innerHeight < 1368) {
      return cboxOptions.maxHeightMd;
    } else {
      return cboxOptions.maxHeightSm;
    }
  },
  onChangeStateDropdown(e) {
    const targetEle = e.target !== undefined ? $(e.target) : $(e);
    const targetEleContainer = targetEle.closest(mfaEnrollCommonSection);
    targetEleContainer.find(mfaEnrollCtyCode).text(targetEle.val());
  },

  updateMfaEnrollIdValues(mfaEnrollType) {
    $(`#${mfaEnrollSmsVerifyBtnId}`).attr('data-type-id', mfaEnrollType);
    $(`#${mfaEnrollSendCodeBtnId}`).attr('data-type-id', mfaEnrollType);
  },

  onChangeMfaTypeDropdown(e) {
    const targetEle = e.target !== undefined ? $(e.target) : $(e);
    if (e.target !== undefined) {
      mfaOktaFunction.removeErrorMessageMfa();
    }
    $(mfaEnforceResendMsgTextEle).addClass('hidden');
    const mfaEnforceTargetMsgEle = $(
      `#mfa-enforcement-${targetEle.val()}-resend-msg`
    );
    if (mfaEnforceTargetMsgEle.length > 0) {
      mfaEnforceTargetMsgEle.removeClass('hidden');
    }
    if (targetEle.val() === mfaEnrollSetupTypeSms) {
      mfaOktaFunction.updateMfaEnforceIconDisplay(mfaEnforceTypeSms);
      mfaOktaFunction.updateMfaEnforceAuthTypeDisplay(mfaEnforceAuthTypeSmsId);
      mfaOktaFunction.updateMfaEnforceContactInfoDisplay(
        mfaEnforceContactInfoText,
        mfaEnrollSetupTypeSms
      );
      mfaOktaFunction.updateMfaEnrollIdValues(mfaEnrollSetupTypeSms);
      $(`#${mfaEnrollSendCodeBtnId}`).text(mfaEnforceSendCodeText);
      $(mfaEnforceResendMsgEle).text(mfaEnrollCodeReSendText);
    } else if (targetEle.val() === mfaEnrollSetupTypeCall) {
      mfaOktaFunction.updateMfaEnforceIconDisplay(mfaEnforceTypeVoice);
      mfaOktaFunction.updateMfaEnforceAuthTypeDisplay(
        mfaEnforceAuthTypeVoiceId
      );
      mfaOktaFunction.updateMfaEnforceContactInfoDisplay(
        mfaEnforceContactInfoText,
        mfaEnrollSetupTypeCall
      );
      mfaOktaFunction.updateMfaEnrollIdValues(mfaEnrollSetupTypeCall);
      $(`#${mfaEnrollSendCodeBtnId}`).text(mfaEnforceVoiceCallText);
      $(mfaEnforceResendMsgEle).text(mfaEnrollCodeReSendVoice);
    } else {
      mfaOktaFunction.updateMfaEnforceIconDisplay(mfaEnforceTypeEmail);
      mfaOktaFunction.updateMfaEnforceAuthTypeDisplay(
        mfaEnforceAuthTypeEmailId
      );
      mfaOktaFunction.updateMfaEnforceContactInfoDisplay(
        mfaEnforceContactInfoEmail,
        mfaEnrollSetupTypeEmail
      );
      mfaOktaFunction.updateMfaEnrollIdValues(mfaEnrollSetupTypeEmail);
      $(`#${mfaEnrollSendCodeBtnId}`).text(mfaEnforceSendCodeText);
      $(mfaEnforceResendMsgEle).text(mfaEnrollCodeReSendText);
    }
    $(mfaEnforceFactorId).val(
      $(`#mfa-enforcement-factor-id-${targetEle.val()}`).val()
    );
  },

  updateMfaEnforceIconDisplay(mfaEnforceIconEle) {
    $(mfaEnforceTypeSection).removeClass('hidden');
    $(mfaEnforceTypeAll).addClass('hidden');
    $(mfaEnforceIconEle).removeClass('hidden');
  },
  updateMfaEnforceAuthTypeDisplay(mfaEnforceAuthSelectedEle) {
    $(mfaEnforceAuthTypeId).removeClass('hidden');
    $(mfaEnforceAuthTypeAll).addClass('hidden');
    $(mfaEnforceAuthSelectedEle).removeClass('hidden');
  },
  updateMfaEnforceContactInfoDisplay(
    mfaEnforceContactSelectedEle,
    mfaEnrollType
  ) {
    $(mfaEnforceContactInfoAll).addClass('hidden');
    $(mfaEnforceContactSelectedEle).removeClass('hidden');
    $(mfaEnforceContactSelectedEle).text(
      $(`#mfa-enforcement-contact-${mfaEnrollType}`).val()
    );
  },
  displayAuthTypeSection(e) {
    let dynamicDropdownEle;
    $(`${mfaEnrollSetupSection}, ${mfaEnrollCommonSection}`).addClass('hidden');
    if (e.target.id === mfaEnrollSmsSetupBtnId) {
      $(mfaEnrollSmsSection).removeClass('hidden');
      dynamicDropdownEle = $(mfaEnrollSmsSection).find(mfaEnrollStateDropdown);
    } else {
      $(mfaEnrollVoiceSection).removeClass('hidden');
      dynamicDropdownEle = $(mfaEnrollVoiceSection).find(
        mfaEnrollStateDropdown
      );
    }
    mfaOktaFunction.onChangeStateDropdown(dynamicDropdownEle);
  },

  formatSmsPhoneNumber(phoneNumberString) {
    let phone = phoneNumberString.replace(/\D/g, '');
    let match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      phone = ''
        .concat(match[1])
        .concat(match[2] ? '.' : '')
        .concat(match[2])
        .concat(match[3] ? '.' : '')
        .concat(match[3]);
    }
    return phone;
  },

  goBackToMfaSetup() {
    $(mfaEnrollCommonSection).addClass('hidden');
    $(mfaEnrollSetupSection).removeClass('hidden');
    $(mfaEnrollSetupSection)
      .find(`#${mfaEnrollSmsSetupBtnId}`)
      .focus();
    $(window).scrollTop($(mfaEnrollSetupSection).offset().top);
  },

  onInputPhoneNumber(e) {
    const numberFormat = numbersOnly(e);
    if (numberFormat) {
      $(e.target).removeClass('error-msg-textbox');
      $(e.target)
        .parents(mfaEnrollPhoneSection)
        .find('.error-msg-text')
        .attr('hidden', true);
      const thisPhone = $(this);
      const curval = $(this).val();
      thisPhone.val(mfaOktaFunction.formatSmsPhoneNumber(curval));
    } else {
      return false;
    }
    return null;
  },

  displayGeneralError(targetElement, errorElement) {
    targetElement.find('.mfa-enroll-invalid-field-error').removeClass('hidden');
    targetElement
      .find(
        '.mfa-enroll-invalid-field-error .mfa-enrollment-type-general-error'
      )
      .addClass('hidden');
    targetElement
      .find(`.mfa-enroll-invalid-field-error, ${errorElement}`)
      .removeClass('hidden');
  },

  validatePhoneNumber(e) {
    const targetEle = $(e.target);
    const targetEleContainer = targetEle.closest(mfaEnrollCommonSection);
    const targetEleValue = targetEleContainer.find(mfaEnrollPhoneInput);

    let patternMismatchEle = targetEle
      .parents(mfaEnrollPhoneSection)
      .find(mfaEnrollInvalidPhoneError);
    let valueMissingEle = targetEle
      .parents(mfaEnrollPhoneSection)
      .find(mfaEnrollEmptyError);
    targetEle.removeClass('error-msg-textbox');
    if (e.target.validity.valueMissing || targetEleValue.val().length < 12) {
      e.preventDefault();
      if (targetEleValue.val().length > 0 && targetEleValue.val().length < 12) {
        patternMismatchEle.attr('hidden', false);
        valueMissingEle.attr('hidden', true);
      } else {
        valueMissingEle.attr('hidden', false);
        patternMismatchEle.attr('hidden', true);
      }
      targetEleValue.addClass('error-msg-textbox');
      if (
        targetEle.attr('id') === mfaEnrollSendCodeBtnId ||
        targetEle.attr('id') === mfaEnrollSmsVerifyBtnId
      ) {
        mfaOktaFunction.displayGeneralError(
          targetEleContainer,
          mfaEnrollInvalidPhoneNumber
        );
      }
      return false;
    } else {
      targetEle.removeClass('error-msg-textbox');
      targetEle
        .parents(mfaEnrollPhoneSection)
        .find('.error-msg-text')
        .attr('hidden', true);
      return true;
    }
  },

  byPassValidatePhoneStep(event) {
    let targetEle = $(event.target);
    let targetEleContainer = targetEle.closest(mfaEnrollCommonSection);
    if (targetEleContainer.find(mfaTypeAuth).val() === mfaTypeAuthEnrollText) {
      return mfaOktaFunction.validatePhoneNumber(event);
    } else {
      return true;
    }
  },

  onClickSendCode(e) {
    const targetEle = $(e.target);
    const targetEleContainer = targetEle.closest(mfaEnrollCommonSection);
    const phoneInputEle = targetEleContainer.find(mfaEnrollPhoneInput);
    let requestURL;
    let submitdata;
    if (mfaOktaFunction.byPassValidatePhoneStep(e)) {
      targetEleContainer
        .find(mfaEnrollPhoneVerify)
        .removeClass('error-msg-textbox')
        .next()
        .attr('hidden', true);
      targetEleContainer.find(mfaEnrollGeneralErrorSection).addClass('hidden');
      targetEleContainer.find(mfaEnrollOtpResendMessage).addClass('hidden');
      if (
        targetEleContainer.find(mfaTypeAuth).val() === mfaTypeAuthEnrollText
      ) {
        const phoneNumberDotRemove = phoneInputEle
          .val()
          .split('.')
          .join('');
        const phoneNumberCtyCode =
          targetEleContainer.find(mfaEnrollCtyCode).text() +
          ' ' +
          phoneNumberDotRemove;
        const objParam = {
          factorType: targetEle.attr('data-type-id'),
          phoneNumber: phoneNumberCtyCode
        };
        if (
          targetEle.text() === mfaEnrollCodeReSendText ||
          targetEle.text() === mfaEnrollCodeReSendVoice
        ) {
          requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.resendCode}`;
          submitdata = {};
        } else {
          requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.sendCode}`;
          submitdata = JSON.stringify(objParam);
        }
      } else {
        const objParam = {
          factorId: $(mfaEnforceFactorId).val()
        };
        requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.getMfaChallenge}`;
        submitdata = JSON.stringify(objParam);
      }
      if (!mfaResendCodeAjaxReq) return false;
      mfaResendCodeAjaxReq = false;
      jsonPost(requestURL, submitdata)
        .then(response => {
          mfaResendCodeAjaxReq = true;
          targetEle.attr('disabled', true);
          if (response.status === mfaEnrollExpiryCheck) {
            mfaOktaFunction.openSessionTimeoutPopup();
          }
          if (
            targetEle.attr('data-type-id') === mfaEnrollSetupTypeSms ||
            targetEle.attr('data-type-id') === mfaEnrollSetupTypeEmail
          ) {
            targetEle.text(mfaEnrollCodeSentText);
            targetEle.attr('aria-label', mfaEnrollCodeSentText);
          } else {
            targetEle.text(mfaEnrollCodeSentVoice);
            targetEle.attr('aria-label', mfaEnrollCodeSentVoice);
          }
          targetEleContainer.find(mfaEnrollVerifyInput).removeClass('hidden');
          setTimeout(function() {
            $(mfaEnrollVerifyInput)
              .find(mfaEnrollPhoneVerify)
              .focus();
          }, 2000);
          mfaOktaFunction.startOtpExpiryTimer(targetEle);
        })
        .catch(error => {
          $('#mfaSessionTimeOut').text(mfaSessionTimeout);
          mfaOktaFunction.openSessionTimeoutPopup();
          mfaResendCodeAjaxReq = true;
        });
    }
  },

  startOtpExpiryTimer(buttonEvent) {
    let otpExpiryTimeDuration = 0;
    let downloadTimer = setInterval(function() {
      if (otpExpiryTimeDuration >= mfaEnrollOtpTimer) {
        clearInterval(downloadTimer);
        buttonEvent.attr('disabled', false);
        if (
          buttonEvent.attr('data-type-id') === mfaEnrollSetupTypeSms ||
          buttonEvent.attr('data-type-id') === mfaEnrollSetupTypeEmail
        ) {
          buttonEvent.text(mfaEnrollCodeReSendText);
          buttonEvent.attr('aria-label', mfaEnrollCodeReSendText);
        } else {
          buttonEvent.text(mfaEnrollCodeReSendVoice);
          buttonEvent.attr('aria-label', mfaEnrollCodeReSendVoice);
        }
        buttonEvent
          .closest(mfaEnrollCommonSection)
          .find(mfaEnrollOtpResendMessage)
          .removeClass('hidden');
      }
      otpExpiryTimeDuration += 1;
    }, 1000);
  },

  onClickVerifyCode(e) {
    let targetEle = $(e.target);
    let targetEleContainer = targetEle.closest(mfaEnrollCommonSection);
    let targetEleInput = targetEleContainer.find(mfaEnrollPhoneVerify);
    let requestURL;
    let submitdata;
    let objParam;
    if (
      targetEleInput.val() !== '' &&
      mfaOktaFunction.byPassValidatePhoneStep(e)
    ) {
      targetEleInput.next().attr('hidden', true);
      targetEleInput.removeClass('error-msg-textbox');
      if (
        targetEleContainer.find(mfaTypeAuth).val() === mfaTypeAuthEnrollText
      ) {
        objParam = {
          passCode: targetEleInput.val(),
          factorType: targetEle.attr('data-type-id')
        };
        requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.verifyCode}`;
      } else {
        objParam = {
          factorId: $(mfaEnforceFactorId).val(),
          passCode: targetEleInput.val()
        };
        requestURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.verifyFactor}`;
      }
      submitdata = JSON.stringify(objParam);
      if (!mfaVerifyCodeAjaxReq) return false;
      mfaVerifyCodeAjaxReq = false;
      jsonPost(requestURL, submitdata)
        .then(response => {
          mfaVerifyCodeAjaxReq = true;
          if (response.status === mfaEnrollExpiryCheck) {
            mfaOktaFunction.openSessionTimeoutPopup();
          }
          if (response.status === mfaEnrollSuccessCheck) {
            const { sessionToken, url } = response;
            document.cookie = `sessionId=${encodeURIComponent(
              sessionToken
            )};secure;path=/`;
            window.location.replace(ACC.sanitizer.sanitizeHtmlDeeply(url));
          } else {
            if (response.status === mfaEnrollSendCodeFail) {
              mfaOktaFunction.displayGeneralError(
                targetEleContainer,
                mfaEnforceGeneralMismatchOtp
              );
            }
          }
        })
        .catch(error => {
          $('#mfaSessionTimeOut').text(mfaSessionTimeout);
          mfaOktaFunction.openSessionTimeoutPopup();
          mfaVerifyCodeAjaxReq = true;
        });
    } else {
      targetEleInput.next().attr('hidden', false);
      targetEleInput.addClass('error-msg-textbox');
      mfaOktaFunction.displayGeneralError(
        targetEleContainer,
        mfaEnrollInvalidCode
      );
    }
  },

  onInputOtpNumber(e) {
    const targetEle = $(e.target);
    targetEle.removeClass('error-msg-textbox');
    targetEle.next().attr('hidden', true);
  },

  updateDropdownOptionValues(itemType, itemTypeLength, currIndex = 0) {
    if (itemTypeLength === 1) {
      itemType = itemType[0];
      $(mfaEnforceFactorId).val(itemType.id);
      $(`#mfa-enforcement-factor-id-${itemType.factorType}`).val(itemType.id);
    } else {
      if (currIndex === 0) {
        $(mfaEnforceFactorId).val(itemType.id);
      }
      $(`#mfa-enforcement-factor-id-${itemType.factorType}`).val(itemType.id);
    }
    $(mfaEnforceTypeDropdown).append(
      $('<option>', {
        value: itemType.factorType,
        text: $(mfaEnforceAuthTypeId)
          .find(`#mfa-enforcement-auth-type-${itemType.factorType}`)
          .text()
      })
    );
    if (
      itemType.factorType === mfaEnrollSetupTypeSms ||
      itemType.factorType === mfaEnrollSetupTypeCall
    ) {
      $(`#mfa-enforcement-contact-${itemType.factorType}`).val(
        itemType.profile.phoneNumber
      );
    } else {
      $(`#mfa-enforcement-contact-${itemType.factorType}`).val(
        itemType.profile.email
      );
    }
  },

  updateAuthDropdownDynamic(serverResponse) {
    if (serverResponse.length > 1) {
      $.each(serverResponse, function(i, item) {
        mfaOktaFunction.updateDropdownOptionValues(
          item,
          serverResponse.length,
          i
        );
      });
    } else {
      $(mfaEnforceTypeDropdown)
        .parent()
        .find('.ui-selectmenu-button')
        .hide();
      mfaOktaFunction.updateDropdownOptionValues(
        serverResponse,
        serverResponse.length
      );
    }
    $(mfaEnforceTypeDropdown).selectmenu('refresh');
    mfaOktaFunction.onChangeMfaTypeDropdown($(mfaEnforceTypeDropdown));
  },

  removeErrorMessageMfa() {
    $(mfaEnrollmentTypeGeneralError).addClass('hidden');
    $('.error-msg-text').attr('hidden', true);
    $(mfaEnrollPhoneVerify)
      .removeClass('error-msg-textbox')
      .val('');
  },
  backTofactorListViaEnter(e) {
    e.stopPropagation();
    if (e.keyCode === 13) {
      $(this).trigger('click');
    }
  },
  openSessionTimeoutPopup() {
    ACC.colorbox.open('', {
      escKey: false,
      overlayClose: false,
      closeButton: false,
      html: $('#mfaSessionTimeoutOverlay').html(),
      onLoad: $('#cboxOverlay').css('position', 'fixed'),
      width: mfaOktaFunction.checkWidth(),
      height: mfaOktaFunction.checkHeight(),
      className: 'mfa-session-timeout-overlay-popup'
    });
  },

  init() {
    $(document).on(
      'keyup',
      '.mfa-enrollment-type__back-link',
      this.backTofactorListViaEnter
    );
    $(mfaEnrollStateDropdown).selectmenu();
    $(document).on(
      'selectmenuchange',
      mfaEnrollStateDropdown,
      this.onChangeStateDropdown
    );
    $(document).on(
      'click',
      '.mfa-enrollment-type__state .ui-selectmenu-button',
      ACC.utility.setDropdownHeight
    );
    $(mfaEnforceTypeDropdown).selectmenu();
    $(document).on(
      'selectmenuchange',
      mfaEnforceTypeDropdown,
      this.onChangeMfaTypeDropdown
    );
    $(document).on('click', mfaEnrollSetup, this.displayAuthTypeSection);
    $(document).on(
      'click',
      '.mfa-enrollment-type-sms-back',
      this.goBackToMfaSetup
    );
    $(document).on(
      'input',
      '#mfa-enrollment-type-phone',
      this.onInputPhoneNumber
    );

    $(document).on(
      'input',
      '#mfa-enrollment-type-phone-voice',
      this.onInputPhoneNumber
    );

    $(document).on(
      'keypress',
      `${mfaEnrollPhoneVerify},${mfaEnrollPhoneInput}`,
      this.onInputOtpNumber
    );
    $(document).on(
      'click',
      '.mfa-enrollment-type-send-btn',
      this.onClickSendCode
    );
    $(document).on(
      'click',
      '.mfa-enrollment-type-verify-btn',
      this.onClickVerifyCode
    );

    if (
      $(mfaTypeAuth).length &&
      $(mfaTypeAuth).val() === mfaTypeAuthEnforceText
    ) {
      const requestEnforceURL = `${ACC.config.encodedContextPath}${API_REFERENCE.mfa.getMfaType}`;
      const submitEnforcedata = {};
      jsonGet(requestEnforceURL, submitEnforcedata)
        .then(response => {
          mfaOktaFunction.updateAuthDropdownDynamic(response);
        })
        .catch(error => {
          $('#mfaSessionTimeOut').text(mfaSessionTimeout);
          mfaOktaFunction.openSessionTimeoutPopup();
        });
    }
    $('.spinner-mask').addClass('hidden');
  }
};
mfaOktaFunction.init();
export default mfaOktaFunction;
